import { useState } from "react";
import ReactDOM from "react-dom";
import { BsPlus } from "react-icons/bs";
import Swal from "sweetalert2";
import $ from "jquery";

import { Modal } from "bootstrap";

import { TableModal } from "./TableModal";
import TableBus from "./TableBus";

function TableField({ passanger, keys }) {
  return (
    <>
      <div className="the-tr row d-none d-md-flex" key={keys + 1}>
        <div className="the-td col-1"> {passanger.firstname} </div>
        <div className="the-td col-2"> {passanger.lastname} </div>
        <div className="the-td col-2"> {passanger.code} </div>
        <div className="the-td col-2"> {passanger.phone} </div>
        <div className="the-td col-2"> {passanger.birthdate} </div>
        <div className="the-td col-3"> {passanger.email} </div>
      </div>
      <div className="the-tr d-md-none" key={keys + 2}>
        <div className="row">
          <div className="col-12 col-sm-6 the-td">
            <b> نام: </b>
            {passanger.firstname}
          </div>
          <div className="col-12 col-sm-6 the-td">
            <b> نام خانوادگی: </b>
            {passanger.lastname}
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-sm-6 the-td">
            <b> کدملی: </b>
            {passanger.code}
          </div>
          <div className="col-12 col-sm-6 the-td">
            <b> شماره تماس: </b>
            {passanger.phone}
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-sm-6 the-td">
            <b> تاریخ تولد: </b>
            {passanger.birthdate}
          </div>
          <div className="col-12 col-sm-6 the-td">
            <b> ایمیل: </b>
            {passanger.email}
          </div>
        </div>
      </div>
    </>
  );
}

export default function TourPassangers({
  passangers,
  addPassanger,
  pastPassangers,
  seats,
  busType,
  changeBusType,
  changeSeats,
  selectedSeats,
  setSelectedSeats,
  capacity,
  main_status,
}) {
  const [info, setInfo] = useState({
    id: -1,
    firstname: "",
    lastname: "",
    code: "",
    phone: "",
    birthdate: "",
    email: "",
  });

  const add = (info) => {
    if (
      ["firstname", "lastname", "code", "phone"].reduce((prevVal, value) => {
        if (prevVal) return prevVal;
        if (info[value] == "") return true;
      }, false)
    ) {
      Swal.fire({
        title: "لطفا نام، نام خانوادگی، کدملی و شماره تماس را وارد کنید.",
        icon: "error",
      });
      return;
    }
    if (!/^(\+98|0)?9\d{9}$/.test(info.phone)) {
      Swal.fire({
        title: "لطفا شماره تماس را به درستی وارد کنید.",
        icon: "error",
      });
      return;
    }
    if (!/^\d{10}$/.test(info.code)) {
      Swal.fire({
        title: "لطفا کد ملی را به درستی وارد کنید.",
        icon: "error",
      });
      return;
    }
    if (info.birthdate != "") {
      info.birthdate = `${info.birthdate.year}/${
        info.birthdate.month.number < 10 ? "0" : ""
      }${info.birthdate.month.number}/${info.birthdate.day < 10 ? "0" : ""}${
        info.birthdate.day
      }`;
    }
    addPassanger(info);
    setInfo({
      id: -1,
      firstname: "",
      lastname: "",
      code: "",
      phone: "",
      birthdate: "",
      email: "",
    });
  };

  return (
    <>
        <div className="the-reserve-table">
          <div className="d-flex flex-column align-items-center table">
            <div className="row d-none d-md-flex the-head">
              <div className="col-1"> نام </div>
              <div className="col-2"> نام خانوادگی </div>
              <div className="col-2"> کد ملی </div>
              <div className="col-2"> شماره تماس </div>
              <div className="col-2"> تاریخ تولد </div>
              <div className="col-3"> ایمیل </div>
            </div>
            {passangers.map((passanger, index) => (
              <TableField
                passanger={passanger}
                key={index * 3}
                keys={index * 3}
              />
            ))}
          </div>
          {capacity == 0 ||
          main_status != 4 ||
          capacity - passangers.length <= 0 ? (
            ""
          ) : (
            <div className="the-btn p-3">
              <button
                className="btn btn-primary"
                data-bs-target="#add-passanger-modal"
                data-bs-toggle="modal"
              >
                <BsPlus style={{ fontSize: "25px", marginLeft: "10px" }} />{" "}
                اضافه نموندن همراه
              </button>
            </div>
          )}
        </div>
          <TableBus
            busType={busType}
            seats={seats}
            changeBusType={changeBusType}
            changeSeats={changeSeats}
            limit={passangers.length + 1}
            selected={selectedSeats}
            setSelected={setSelectedSeats}
          />

      {ReactDOM.createPortal(
        <TableModal
          info={info}
          pastPassangers={pastPassangers}
          setInfo={setInfo}
          dismiss={capacity - passangers.length <= 0}
          add={add}
        />,
        document.querySelector(".modals")
      )}
    </>
  );
}
